import { useMemo } from 'react';
import {
	QUICKSTART_UI_STATUS,
	useQuickstartUiStatus,
} from '@atlassian/jira-onboarding-quickstart-core/src/services';
import { usePreviousWithInitial } from '@atlassian/jira-platform-react-hooks-use-previous';

/* do not want spotlight to interfere with any open modals from the quickstart menu */
export const useOverlapsQuickstart = () => {
	const [quickstartStatus] = useQuickstartUiStatus();
	const prevQuickstartStatus = usePreviousWithInitial(quickstartStatus);

	return useMemo(
		() => ({
			overlapsWithQuickstart:
				quickstartStatus === QUICKSTART_UI_STATUS.NOT_LOADED ||
				quickstartStatus === QUICKSTART_UI_STATUS.OPEN ||
				prevQuickstartStatus === 'OPEN',
		}),
		[prevQuickstartStatus, quickstartStatus],
	);
};
